export function getUserDisplayName(user, { fallback = "" } = {}) {
  const firstName = String(user?.firstName ?? "").trim();
  const lastName = String(user?.lastName ?? "").trim();
  const fullName = `${firstName} ${lastName}`.trim();
  if (fullName) return fullName;

  const userName = String(user?.userName ?? user?.username ?? "")
    .replace(/^@/, "")
    .trim();
  if (userName) return userName;

  return fallback;
}

